module.exports = __webpack_public_path__ + "media/images/icons/outlined/border-right-8a5d885708534fa858f43c3e029e2e5d.svg";